import React from "react";
import {
  Datagrid,
  List,
  Loading,
  TextField,
  TopToolbar,
} from "react-admin";
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { CustomExportButton, CustomImportButton } from "../../Signet/util";

const NetsuiteInlayFinishResource = "netsuite/inlay-finish";

const useStyles = makeStyles({
  container: {
    width: "100%",
    padding: 0,
  },
});

const InlayFinishListActions = (props) => {
  const classes = useStyles();
  return (
    <TopToolbar className={classes.container}>
      <Box
        display={"flex"}
        alignItems={"flex-end"}
        justifyContent="space-between"
        width={"100%"}
        sx={{ paddingBottom: "14px", paddingTop: "14px" }}
      >
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent="space-between"
        >
        </Box>
        <Box display={"flex"} justifyItems={"flex-end"} sx={{ gap: "20px" }}>
          <CustomImportButton resource={NetsuiteInlayFinishResource} />
          <CustomExportButton resource={NetsuiteInlayFinishResource} />
        </Box>
      </Box>
    </TopToolbar>
  );
};

const InlayFinishList = (props) => {
  const { permissions } = props;

  if (!permissions) return <Loading />;
  return (
    <List {...props} exporter={false} bulkActionButtons={false} actions={<InlayFinishListActions />}>
      <Datagrid rowClick={null}>
        <TextField source="first_inlay_finish" label="First Inlay Finish" sortable={false} />
        <TextField source="second_inlay_finish" label="Second Inlay Finish" sortable={false} />
        <TextField source="netsuite_id" sortable={false} label="Netsuite ID" />
        <TextField source="netsuite_value" sortable={false} label="Netsuite Value" />
      </Datagrid>
    </List>
  );
};

export default InlayFinishList;
